import { AlteracaoStatus } from './alteracao-status.enum';
import { AlteracaoDto } from './alteracao.dto';

export class AlteracaoDetalhesDto extends AlteracaoDto {
  status: AlteracaoStatus;
}
